export default __webpack_public_path__ + "static/media/filters.572b16f9.svg";